<template>
  <div :key="technologyFileBrowseKey">
    <a-row :gutter="10">
      <a-col :md="6" :sm="24">
        <a-card class="pannel-scroll">
          <a-input-search
            style="margin-bottom: 0px; margin-top: 8px"
            placeholder="请输入要搜索的内容"
            enter-button="搜索"
            size="large"
            @search="handleTreeSearch"
          />
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              当前选择分类：{{ textTreeSelectedTitles }}
              <span style="margin-left: 10px; color: #1890ff"> </span>
              <a v-if="textTreeSelectedTitles" class="cancel-tree-seleted" @click="treeSeletedCancel">取消</a>
            </div>
          </a-alert>
          <a-tree
            draggable
            @drop="handleTreeDragenter"
            :tree-data="treeData"
            :expanded-keys="treeExpandedKeys"
            :auto-expand-parent="treeAutoExpandParent"
            :selectedKeys.sync="treeSelectedKeyValue"
            @expand="handleTreeExpand"
          >
            <template slot="title" slot-scope="{ key: treeKey, title, sort, parentId }">
              <a-dropdown :trigger="['contextmenu']">
                <span v-if="title.indexOf(treeSearchValue) > -1">
                  {{ title.substr(0, title.indexOf(treeSearchValue)) }}
                  <span style="color: #f50">{{ treeSearchValue }}</span>
                  {{ title.substr(title.indexOf(treeSearchValue) + treeSearchValue.length) }}
                </span>
                <span v-else>{{ title }}</span>
                <template #overlay>
                  <a-menu
                    v-has="'technologyFileBrowse:add'"
                    @click="({ key: menuKey }) => handleTreeMenuClick(treeKey, menuKey, title, parentId)"
                  >
                    <a-menu-item key="moveToUp">上移</a-menu-item>
                    <a-menu-item key="moveToDown">下移</a-menu-item>
                    <a-menu-item key="addChildren">添加下级</a-menu-item>
                    <a-menu-item key="addBrother">添加同级</a-menu-item>
                    <a-menu-item key="moveToOut">移至最外层</a-menu-item>
                    <a-menu-item key="edit">修改名称</a-menu-item>
                    <a-menu-item key="delete">删除</a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </template>
          </a-tree>
          <div>
            <a-spin tip="Loading..." :spinning="isTreeLoading"> </a-spin>
          </div>
        </a-card>
        <div class="drawer-bootom-button">
          <a-dropdown :trigger="['click']" placement="topCenter">
            <a-menu slot="overlay">
              <a-menu-item key="6" @click="handleTreeCloseAll">合并所有</a-menu-item>
              <a-menu-item key="6" @click="hanleTreeExpandAll">展开所有</a-menu-item>
              <a-menu-item key="6" v-if="textTreeSelectedTitles" @click="treeSeletedCancel">取消选中</a-menu-item>
            </a-menu>
            <a-button>
              树操作
              <a-icon type="up" />
            </a-button>
          </a-dropdown>
        </div>
      </a-col>
      <a-col :md="18" :sm="24">
        <a-card class="pannel-scroll-right">
          <div>
            <div class="table-page-search-wrapper">
              <a-form layout="inline" @keyup.enter.native="searchQuery">
                <div class="div-query-banner">
                  <a-form-item label="文件名">
                    <j-input v-model="queryParam.originalFileName"></j-input>
                  </a-form-item>
                  <a-form-item label="文件编码">
                    <j-input v-model="queryParam.fileCode"></j-input>
                  </a-form-item>
                  <a-form-item label="文件来源">
                    <j-dict-select-tag
                      ref="dictRefSource"
                      type="list"
                      v-model="queryParam.fileSource"
                      :dictCode="dictCodeFileSource"
                      placeholder="请选择文件来源"
                    />
                  </a-form-item>
                  <a-form-item label="文件类型">
                    <j-dict-select-tag
                      ref="dictRefType"
                      type="list"
                      v-model="queryParam.fileType"
                      :dictCode="dictCodeFileType"
                      placeholder="请选择文件来源"
                    />
                  </a-form-item>
                  <a-button
                    type="primary"
                    class="query-banner-btn"
                    @click="searchQuery"
                    icon="search"
                    style="margin-left: 21px"
                    >查询</a-button
                  >
                  <a-button
                    type="primary"
                    class="query-banner-btn"
                    @click="searchReset"
                    icon="reload"
                    style="margin-left: 8px"
                    >重置</a-button
                  >
                </div>
              </a-form>
            </div>
            <div class="table-operator">
              <a-button
                @click="handleAdd"
                type="primary"
                icon="plus"
                v-has="'technologyFileBrowse:add'"
                :key="technologyFileBrowseKey"
                >新增</a-button
              >
            </div>
            <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
              <div slot="message">
                当前选择分类：{{ textTreeSelectedTitles }}
                <span style="margin-left: 10px; color: #1890ff"> </span>
                <a class="cancel-tree-seleted" v-if="textTreeSelectedTitles" @click="treeSeletedCancel">取消</a>
              </div>
            </div>
            <a-table
              ref="table"
              size="middle"
              bordered
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :loading="loading"
              :rowSelection="{ fixed: true, selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
              @change="handleTableChange"
            >
              <template slot="browsepdf" slot-scope="text, record">
                <a @click="handleBrowse(text)">查看</a>
                <a-divider type="vertical" />
                <!-- <a   @click="handleDownloadFile(text, record.originalFileName)">下载</a> -->
                <a @click="downloadFile(text, record.originalFileName)" v-has="'technologyFileBrowse:add'">下载</a>
              </template>
              <template slot="fileSlot" slot-scope="text">
                <span v-if="!text" style="font-size: 12px; font-style: italic">无此文件</span>
                <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="uploadFile(text)">
                  下载
                </a-button>
              </template>
              <span slot="action" slot-scope="text, record">
                <a @click="handleEdit(record)" v-has="'technologyFileBrowse:add'">编辑</a>
                <a-divider type="vertical" />
                <a-dropdown v-has="'technologyFileBrowse:add'">
                  <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
                  <a-menu slot="overlay">
                    <a-menu-item>
                      <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                        <a>删除</a>
                      </a-popconfirm>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </span>
            </a-table>
          </div>
        </a-card>
      </a-col>
    </a-row>
    <technology-file-browse-modal
      :classIdTreeData="treeData"
      ref="modalForm"
      @ok="modalFormOk"
    ></technology-file-browse-modal>
    <a-modal
      :title="textTreeOptionsTitle + ':' + textTreeOptionsContent"
      :visible="isShowTreeOptionModal"
      :confirm-loading="isShowTreeOptionLoading"
      @ok="handleTreeOptionConfirm"
      @cancel="isShowTreeOptionModal = false"
    >
      <a-input v-model="treeOptionsParams" placeholder="请输入内容！"></a-input>
    </a-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import {
  getCommonFileManageClassList,
  deleteCommonFileManage,
  addCommonFileManage,
  editCommonFileManageClassList,
  sortCommonFileManage,
} from '@/api/api.js'
import TechnologyFileBrowseModal from './modules/TechnologyFileBrowseModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { PaperlessMixin } from './MixinsOfGisPaperless.js'
import JInput from '@/components/jeecg/JInput.vue'
import { downFile } from '@/api/manage.js'
import axios from 'axios'

const getParentKey = (key, tree) => {
  let parentKey
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if (node.children) {
      if (node.children.some((item) => item.key === key)) {
        parentKey = node.key
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children)
      }
    }
  }
  return parentKey
}
export default {
  mixins: [JeecgListMixin, PaperlessMixin],
  components: { JInput, TechnologyFileBrowseModal },
  data() {
    return {
      treeData: [],
      treeDataArr: [],
      treeDataResultArr: [],
      treeExpandedKeys: [],
      treeDropdownSelected: {
        key: '',
        value: '',
      },
      treeDropdownChoosedType: '',
      treeDropdownChoosedTypePid: '',
      treeAutoExpandParent: true,
      treeSelectedKeyValue: [],
      treeSearchValue: '',
      isTreeLoading: false,
      isShowTreeOptionModal: false,
      isShowTreeOptionLoading: false,
      treeOptionsParams: '',
      disableMixinCreated: true,
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '分类',
          align: 'center',
          dataIndex: 'className',
        },
        {
          title: '文件编码',
          align: 'center',
          dataIndex: 'fileCode',
        },
        {
          title: '文件名',
          align: 'center',
          dataIndex: 'originalFileName',
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime',
        },
        {
          title: '下载次数',
          align: 'center',
          dataIndex: 'openCount',
        },
        {
          title: '文件来源',
          align: 'center',
          dataIndex: 'fileSource_dictText',
        },
        {
          title: '文件类型',
          align: 'center',
          dataIndex: 'fileType_dictText',
        },
        {
          title: '查看',
          align: 'center',
          key: 'browsepdf',
          dataIndex: 'fileUrl',
          scopedSlots: { customRender: 'browsepdf' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/factory/base/commonFileManage/list',
        delete: '/factory/base/commonFileManage/delete',
        deleteBatch: '/jeecg-goldenhome/factory/base/commonFileManage/deleteBatch',
      },
      dictCodeFileSource: '',
      dictCodeFileType: '',
    }
  },
  methods: {
    downloadFile(url, fileName) {
      var x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function (e) {
        //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
        var url = window.URL.createObjectURL(x.response)
        var a = document.createElement('a')
        a.href = url
        a.download = fileName
        a.click()
      }
      x.send()
    },
    handleAdd: function () {
      if (!this.treeSelectedKeyValue || !this.treeSelectedKeyValue.length) {
        this.$message.error('请至少选择一个分类')
        return
      }
      this.$refs.modalForm.add({
        classId: this.treeSelectedKeyValue[0],
        className: this.textTreeSelectedTitles,
      })
      this.$refs.modalForm.title = '新增'
      this.$refs.modalForm.disableSubmit = false
    },
    treeDataOnload() {
      this.treeData = []
      this.isTreeLoading = true
      getCommonFileManageClassList({}).then((res) => {
        this.isTreeLoading = false
        if (res.success) {
          this.treeDataResultArr = res.result
          this.treeData = this.toTree(res.result)
          //重新排序
          //展开全部数据
          this.treeDataArr = []
          const generateList = (data) => {
            for (let i = 0; i < data.length; i++) {
              const node = data[i]
              this.treeDataArr.push({ key: node.id, title: node.nodeName })
              if (node.children) {
                generateList(node.children)
              }
            }
          }
          generateList(this.treeData)
          this.handleTreeSearch('')
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    toTree(data) {
      let result = []
      if (!Array.isArray(data)) {
        return result
      }
      data.forEach((item, index) => {
        data[index].title = item.nodeName
        data[index].key = item.id
        data[index].value = item.id
        data[index].sort = item.sort
        data[index].scopedSlots = { title: 'title' }
        delete item.children
      })
      let map = {}
      data.forEach((item) => {
        map[item.id] = item
      })
      data.forEach((item) => {
        let parent = map[item.parentId]
        if (parent) {
          ;(parent.children || (parent.children = [])).push(item)
        } else {
          result.push(item)
        }
      })
      //重新根据sort排序
      const sortFun = (arrarList) => {
        arrarList.sort((a, b) => {
          return a.sort - b.sort
        })
        arrarList.forEach((item) => {
          if (item.children && item.children.length > 0) {
            sortFun(item.children)
          }
        })
      }
      sortFun(result)
      return result
    },
    handleTreeMenuClick(treeKey, menuKey, title, parentId) {
      this.treeDropdownSelected.key = treeKey
      this.treeDropdownSelected.title = title
      switch (menuKey) {
        case 'moveToUp':
          this.handleMoveToUp(treeKey, menuKey, title, parentId)
          break
        case 'moveToDown':
          this.handleMoveToDown(treeKey, menuKey, title, parentId)
          break
        case 'addChildren':
          this.treeDropdownChoosedType = 'addChildren'
          this.treeOptionsParams = ''
          this.isShowTreeOptionModal = true
          break
        case 'addBrother':
          this.treeDropdownChoosedType = 'addBrother'
          this.treeOptionsParams = ''
          this.isShowTreeOptionModal = true
          break
        case 'edit':
          this.treeDropdownChoosedType = 'edit'
          this.treeOptionsParams = ''
          this.treeDropdownChoosedTypePid = parentId
          this.isShowTreeOptionModal = true
          break
        case 'delete':
          this.$antdConfirm({
            title: '删除?',
            content: `是否删除分类:${title}`,
            onOk: () => {
              this.isShowTreeOptionLoading = true
              deleteCommonFileManage({ id: treeKey })
                .then((res) => {
                  if (res.code === 200) {
                    this.$message.success(res.message)
                    this.treeSelectedKeyValue = []
                    this.treeDataOnload()
                    this.isShowTreeOptionModal = false
                  } else {
                    this.$message.error(res.message)
                  }
                })
                .catch((err) => {
                  this.$message.error(res.message)
                })
                .finally(() => {
                  this.isShowTreeOptionLoading = false
                })
            },
            onCancel() {},
          })
          break
        case 'moveToOut':
          this.$antdConfirm({
            title: '移至外层?',
            content: `是否将《${title}》移动到最外层`,
            onOk: () => {
              this.isShowTreeOptionLoading = true
              editCommonFileManageClassList({ id: treeKey, parentId: '' })
                .then((res) => {
                  if (res.code === 200) {
                    this.$message.success(res.message)
                    this.treeSelectedKeyValue = []
                    this.treeDataOnload()
                    this.isShowTreeOptionModal = false
                  } else {
                    this.$message.error(res.message)
                  }
                })
                .catch((err) => {
                  this.$message.error(res.message)
                })
                .finally(() => {
                  this.isShowTreeOptionLoading = false
                })
            },
            onCancel() {},
          })
          break
        default:
          return
          break
      }
    },
    handleMoveToUp(treeKey, menuKey, title, parentId) {
      let arrBros = this.treeDataResultArr.filter((item) => {
        return item.parentId === parentId
      })
      arrBros.sort((a, b) => {
        return a.sort - b.sort
      })
      arrBros.some((item, index) => {
        if (item.id === treeKey) {
          if (index === 0) {
            this.$message.error('已经在最上面了')
          } else {
            this.isShowTreeOptionLoading = true
            sortCommonFileManage({
              idVo: item.id,
              idVoTemp: arrBros[index - 1].id,
              sortVo: item.sort,
              sortVoTemp: arrBros[index - 1].sort,
            })
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success(res.message)
                  this.treeDataOnload()
                  this.isShowTreeOptionModal = false
                } else {
                  this.$message.error(res.message)
                }
              })
              .catch((err) => {
                this.$message.error(res.message)
              })
              .finally(() => {
                this.isShowTreeOptionLoading = false
              })
          }
          return true
        }
        return false
      })
    },
    handleMoveToDown(treeKey, menuKey, title, parentId) {
      let arrBros = this.treeDataResultArr.filter((item) => {
        return item.parentId === parentId
      })
      arrBros.sort((a, b) => {
        return a.sort - b.sort
      })
      arrBros.some((item, index) => {
        if (item.id === treeKey) {
          if (index === arrBros.length - 1) {
            this.$message.error('已经在最下面了')
          } else {
            this.isShowTreeOptionLoading = true
            sortCommonFileManage({
              idVo: item.id,
              idVoTemp: arrBros[index + 1].id,
              sortVo: item.sort,
              sortVoTemp: arrBros[index + 1].sort,
            })
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success(res.message)
                  this.treeDataOnload()
                  this.isShowTreeOptionModal = false
                } else {
                  this.$message.error(res.message)
                }
              })
              .catch((err) => {
                this.$message.error(res.message)
              })
              .finally(() => {
                this.isShowTreeOptionLoading = false
              })
          }
          return true
        }
        return false
      })
    },
    handleTreeOptionConfirm() {
      if (!this.treeOptionsParams) {
        this.$toast('请输入内容')
        return
      }
      let parentId = ''
      if (this.treeDropdownChoosedType === 'addChildren') {
        parentId = this.treeDropdownSelected.key
      } else if (this.treeDropdownChoosedType === 'addBrother') {
        this.treeDataResultArr.some((item) => {
          if (item.id === this.treeDropdownSelected.key) {
            parentId = item.parentId
          }
        })
      } else if (this.treeDropdownChoosedType === 'edit') {
        this.isShowTreeOptionLoading = true
        editCommonFileManageClassList({
          id: this.treeDropdownSelected.key,
          nodeName: this.treeOptionsParams,
          parentId: this.treeDropdownChoosedTypePid,
        })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success(res.message)
              this.treeDataOnload()
              this.isShowTreeOptionModal = false
            } else {
              this.$message.error(res.message)
            }
          })
          .catch((err) => {
            this.$message.error(res.message)
          })
          .finally(() => {
            this.isShowTreeOptionLoading = false
          })
        return
      } else {
        this.$message.error('找不到本次操作，请检查操作是否正确！')
      }
      let params = {
        nodeName: this.treeOptionsParams,
        parentId,
      }
      this.isShowTreeOptionLoading = true
      addCommonFileManage(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('添加成功')
            this.treeDataOnload()
            this.isShowTreeOptionModal = false
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((err) => {
          this.$message.error(res.message)
        })
        .finally(() => {
          this.isShowTreeOptionLoading = false
        })
    },
    treeSeletedCancel() {
      this.treeSelectedKeyValue.pop()
    },
    handleTreeExpand(expandedKeys) {
      this.treeExpandedKeys = expandedKeys
      this.treeAutoExpandParent = false
    },
    handleTreeSearch(values) {
      this.handleTreeCloseAll()
      const expandedKeys = this.treeDataArr
        .map((item) => {
          if (item.title.indexOf(values) > -1) {
            return getParentKey(item.key, this.treeData)
          }
          return null
        })
        .filter((item, i, self) => item && self.indexOf(item) === i)
      this.treeAutoExpandParent = true
      this.treeSearchValue = values
      this.treeExpandedKeys = expandedKeys
    },
    handleTreeCloseAll() {
      this.treeAutoExpandParent = false
      this.treeSearchValue = ''
      this.treeExpandedKeys = []
    },
    hanleTreeExpandAll() {
      this.handleTreeSearch('')
    },
    getQueryParams() {
      console.log(this.treeSelectedKeyValue)
      //获取查询条件
      let sqp = {}
      if (this.superQueryParams) {
        sqp['superQueryParams'] = encodeURI(this.superQueryParams)
      }
      var param = Object.assign(sqp, this.queryParam, this.isorter, this.filters)
      param.field = this.getQueryField()
      param.pageNo = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      param.classId = this.treeSelectedKeyValue[0]
      return filterObj(param)
    },
    handleBrowse(text) {
      let pdtPath = 'http://192.168.5.123:8050/static/pdf/web/viewer.html?file=' + encodeURIComponent(text)
      window.open(pdtPath, '_blank')
    },
    handleDownloadFile(url, fileName) {
      const service = axios.create({
        //baseURL: '/jeecg-boot',
        timeout: 9000, // 请求超时时间
      })
      service({
        method: 'post',
        url: url,
        // 这里可以在header中加一些东西，比如token
      })
        .then((res) => {
          console.log('response: ', res)
          // new Blob([data])用来创建URL的file对象或者blob对象
          let url = window.URL.createObjectURL(new Blob([res.data]))
          // 生成一个a标签
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          // 生成时间戳
          let timestamp = new Date().getTime()
          link.download = fileName
          document.body.appendChild(link)
          link.click()
        })
        .catch((error) => {
          console.log('response: ', error)
        })
    },
    handleTreeDragenter({ event, node, dragNode, dragNodesKeys }) {
      const dragKey = dragNode.eventKey
      const dropKey = node.eventKey
      let dragObj
      let dropObj
      this.treeDataResultArr.forEach((item) => {
        if (item.id === dragKey) {
          dragObj = item
        } else if (item.id === dropKey) {
          dropObj = item
        }
      })
      console.log(dragObj)
      console.log(dropObj)
      this.$antdConfirm({
        title: '拖动?',
        content: `是否将:《${dragObj.nodeName}》移动到《${dropObj.nodeName}》下`,
        onOk: () => {
          this.isShowTreeOptionLoading = true
          editCommonFileManageClassList({ id: dragObj.id, parentId: dropObj.id })
            .then((res) => {
              if (res.code === 200) {
                this.$message.success(res.message)
                this.treeSelectedKeyValue = []
                this.treeDataOnload()
                this.isShowTreeOptionModal = false
              } else {
                this.$message.error(res.message)
              }
            })
            .catch((err) => {
              this.$message.error(res.message)
            })
            .finally(() => {
              this.isShowTreeOptionLoading = false
            })
        },
        onCancel() {},
      })
    },
  },
  computed: {
    textTreeOptionsTitle() {
      switch (this.treeDropdownChoosedType) {
        case 'addChildren':
          return '添加下级'
          break
        case 'addBrother':
          return '添加同级'
          break
        case 'edit':
          return '修改名称'
          break
        default:
          return ''
          break
      }
    },
    textTreeOptionsContent() {
      return this.treeDropdownSelected.title
    },
    textTreeSelectedTitles() {
      let selectedId = this.treeSelectedKeyValue[0]
      if (selectedId) {
        let SelectedObj = this.treeDataResultArr.filter((item) => {
          if (item.id === selectedId) {
            return true
          }
        })
        return SelectedObj[0].nodeName
      } else {
        return ''
      }
    },
  },
  watch: {
    treeSelectedKeyValue(newVAL, oldVal) {
      // if (!newVAL || !newVAL.length) {
      //   this.treeSelectedKeyValue = oldVal
      //   this.loadData(1)
      //   return
      // }
      this.loadData(1)
    },
  },
  async created() {
    await this.loginForUserName()
    this.dictCodeFileSource = 'bus_common_file_source'
    this.dictCodeFileType = 'bus_common_file_type'
    this.treeDataOnload()
    this.$set(this.treeDropdownSelected, 'key', '')
    this.$set(this.treeDropdownSelected, 'title', '')
    this.loadData(1)
  },
}
</script>

<style lang="less" scoped>
.pannel-scroll {
  height: 700px;
  overflow-y: scroll;
}
.pannel-scroll-right {
  height: 800px;
  overflow-y: scroll;
  min-width: 1500px;
  overflow-x: scroll;
}
.margin-left-10 {
  margin-left: 20px;
}
.drawer-bootom-button {
  /*position: absolute;*/
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: left;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.totals-p {
  width: 100px;
  position: relative;
  top: -45px;
  left: 10px;
  font-size: 16px;
}
.totals-span {
  color: #1890ff;
}
.color-red {
  color: red;
}
.color-blue {
  color: #1890ff;
}
.search-banner-div {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 15px;
}
.isupdate-radio-div .ant-radio-group {
  white-space: nowrap;
}
.search-input-bar {
  flex-shrink: 5;
  margin-top: 0px !important;
}
.bar-title-p {
  margin-bottom: 0px !important;
  white-space: nowrap;
  font-size: 17px;
  margin: 0px 10px;
}
.ant-table td {
  white-space: nowrap !important;
}
.div-query-banner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin: 20px 0px;
  & > *:nth-child(n) {
    width: 200px;
  }
  & > *:nth-child(n + 2) {
    margin-left: 12px;
  }
  & > .query-banner-btn:nth-child(n) {
    width: 100px;
  }
}
</style>
